__turbopack_context__.v({
  "className": "michroma_13fadaaa-module__49JlZG__className",
  "variable": "michroma_13fadaaa-module__49JlZG__variable",
});
